"use strict";
try {
    module.exports.XMLHttpRequest = XMLHttpRequest;
}
catch (error) {
    console.log("Warning: XMLHttpRequest is not defined");
    module.exports.XMLHttpRequest = null;
}
